export default async synchronizer => {
    await synchronizer.$store.dispatch('assets/getXbtsAssets');
}
